<template>
    <div class="search-results container" :ref="'careers-results'">
        <h1 class="search-results__header">Find your perfect career</h1>
        <h3 class="search-results__subheading" v-if="!results">No results found</h3>
        <h2 class="search-results__subheading" v-else>{{ results.total }} Results Match Your Search</h2>
        <div class="search-results__container" v-if="results.data">
            <template v-for="(result, index ) in results.data">
                <!-- <banner v-if="index === 4" :business_areas="business_areas" :privacy_policy_url="privacy_policy_url" :terms_url="terms_url"></banner> -->
                <careers-results-card :result="result" :index="index" :result_url="result_url" :key="'careers-results-card-' + index"></careers-results-card>
            </template>
            <careers-results-paging :pages="paging" v-on:change-page="fetchResults"></careers-results-paging>
        </div>
    </div>
</template>

<script>
import CareersResultsPaging from '../components/CareersResultsPaging.vue'
import CareersResultsCard from '../components/CareersResultsCard.vue'
import Banner from '../components/Banner.vue'

export default {
    props: [
        'results',
        'paging',
        'result_url',
        'business_areas',
        'privacy_policy_url',
        'terms_url'
    ],

    components: {
        CareersResultsPaging,
        CareersResultsCard,
        Banner,
    },

    methods:{
        fetchResults(page) {
            this.$emit('fetchResults', page)
            this.$emit('scrollToResults', 'paginationScrollTarget')
        }
    }
}

</script>

